var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackplusicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.25C5.67405 0.25 5.84097 0.319141 5.96404 0.442211C6.08711 0.565282 6.15625 0.732202 6.15625 0.90625V4.84375H10.0938C10.2678 4.84375 10.4347 4.91289 10.5578 5.03596C10.6809 5.15903 10.75 5.32595 10.75 5.5C10.75 5.67405 10.6809 5.84097 10.5578 5.96404C10.4347 6.08711 10.2678 6.15625 10.0938 6.15625H6.15625V10.0938C6.15625 10.2678 6.08711 10.4347 5.96404 10.5578C5.84097 10.6809 5.67405 10.75 5.5 10.75C5.32595 10.75 5.15903 10.6809 5.03596 10.5578C4.91289 10.4347 4.84375 10.2678 4.84375 10.0938V6.15625H0.90625C0.732202 6.15625 0.565282 6.08711 0.442211 5.96404C0.319141 5.84097 0.25 5.67405 0.25 5.5C0.25 5.32595 0.319141 5.15903 0.442211 5.03596C0.565282 4.91289 0.732202 4.84375 0.90625 4.84375H4.84375V0.90625C4.84375 0.732202 4.91289 0.565282 5.03596 0.442211C5.15903 0.319141 5.32595 0.25 5.5 0.25V0.25Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackplusicon);
export default __webpack_public_path__ + "static/media/blackplusicon.0cb31722b709a16b75aa9ee22c2d2681.svg";
export { ForwardRef as ReactComponent };